import React, {useState} from "react"

const applyStyle = (html,css) => {
  return `${html}<style>${css}</style>`
}

const HtmlCssExample = ({id,htmlCode,cssCode,title}) => {
  let [html,setHtml] = useState(htmlCode);
  let [css,setCss] = useState(cssCode);
  const onUpdateHtml = (e) => {
    setHtml(e.target.value);
  }
  const onUpdateCss = (e) => {
    setCss(e.target.value);
  }

    return <div className="css-html">
      <div className="textarea"> HTML <textarea id={id+"-html"} title={"HTML"} type="htmlbars" value={html} onChange={onUpdateHtml}></textarea></div>
      <div className="textarea"> CSS<textarea id={id+"-css"} title={"CSS"} type="css" value={css} onChange={onUpdateCss}></textarea></div>
      <div className="css-html-code">
        <div>Result</div>
        <div className="html-css-content" dangerouslySetInnerHTML={{__html: applyStyle(html,css)}}></div>
      </div>
    </div>
}

export default HtmlCssExample
